export const getTrackFeatures = data => {
  if (data.layer_id !== "TagilPublicTransport?format=vehicles") {
    const filteredData = filterFromBadValues(data.data);
    const features = filteredData.map((e, i) => {
      const coordinates = [e.from_point.coordinates, e.to_point.coordinates];
      e.geom = {
        type: "LineString",
        coordinates
      };
      e.id = `track_id:${e.from_time}${i}`;

      return e;
    });

    return features;
  } else {
    return [
      {
        id: "TagilPublicTransport?format=vehicles",
        geom: data.data.geom || { coordinates: [], type: "LineString" }
      }
    ];
  }
};

const filterFromBadValues = data => {
  return data.filter(
    e =>
      e.distance &&
      e.avg_speed &&
      e.to_time &&
      e.from_time &&
      e.to_point &&
      e.from_point
  );
};
